<template>
  <div>
    <v-dialog v-model="showFeedbackDialog" width="500">
      <v-card class="py-4 px-6">
        <v-card-title
          class="blue-grey--text text--darken-3 h6 ma-0 pa-0 mb-3"
          >{{
            $t('insights.feedback_for_insight', { name: name })
          }}</v-card-title
        >
        <v-card-text class="ma-0 pa-0">
          <p class="ma-0 pa-0 blue-grey--text text--darken-1 font-size-16 mb-3">
            {{ $t('insights.feedback_subtitle') }}
          </p>
          <div class="mb-6 d-flex">
            <div
              class="d-flex rounded-circle align-center justify-center me-1"
              style="height:32px; width: 32px"
              :class="{ 'blue lighten-2': selection === 'like' }"
            >
              <v-btn
                color="blue lighten-2"
                x-small
                icon
                :ripple="false"
                @click="selection = 'like'"
              >
                <v-icon
                  size="16"
                  :color="selection === 'like' ? 'blue' : 'blue-grey'"
                  >{{
                    selection === 'like'
                      ? 'mdi-thumb-up'
                      : 'mdi-thumb-up-outline'
                  }}</v-icon
                >
              </v-btn>
            </div>
            <div
              class="d-flex rounded-circle align-center justify-center"
              style="height:32px; width: 32px"
              :class="{ 'blue lighten-2': selection === 'dislike' }"
            >
              <v-btn
                color="blue lighten-2"
                x-small
                icon
                :ripple="false"
                @click="selection = 'dislike'"
              >
                <v-icon
                  size="16"
                  :color="selection === 'dislike' ? 'blue' : 'blue-grey'"
                  >{{
                    selection === 'dislike'
                      ? 'mdi-thumb-down'
                      : 'mdi-thumb-down-outline'
                  }}</v-icon
                >
              </v-btn>
            </div>
          </div>

          <v-textarea
            v-model="feedbackComments"
            outlined
            no-resize
            rows="3"
            autoGrow
            :label="$t('insights.feedback_label')"
          />
        </v-card-text>
        <v-card-actions class="ma-0 pa-0">
          <v-spacer></v-spacer>
          <v-btn color="blue-grey darken-1" text rounded @click="handleCancel">
            {{ $t('common.button.cancel') }}
          </v-btn>
          <v-btn color="primary" rounded @click="handleSend(widget)">
            {{ $t('common.button.send') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-chip
      color="white"
      class="feedback-chip elevation-2 show-hover px-2 py-1"
      style="height: 24px"
    >
      <v-icon
        size="16"
        class="me-1 feedback-icon"
        @click="handleLikeClick(widget)"
      >
        {{ likeIcon }}
      </v-icon>
      <v-icon
        v-if="!likeSent"
        size="16"
        class="feedback-icon"
        @click="showFeedbackDialog = true"
      >
        {{ dislikeIcon }}
      </v-icon>
      <p
        v-if="likeSent"
        class="ma-0 pa-0 blue--text font-weight-500 font-size-12"
        style="line-height: 16px; letter-spacing: 0.4px;"
      >
        {{ $t('insights.thank_you') }}
      </p>
    </v-chip>
  </div>
</template>

<script>
import trackingMixin from '@/mixins/tracking/trackerMixin.vue'
import mixin from '@/mixins/mixin.vue'
import _ from 'lodash'

export default {
  name: 'FeedbackChip',

  mixins: [trackingMixin, mixin],

  props: {
    widget: String,
  },

  data() {
    return {
      showFeedbackDialog: false,
      feedbackComments: '',
      likeIcon: 'mdi-thumb-up-outline',
      dislikeIcon: 'mdi-thumb-down-outline',
      likeSent: false,
      selection: 'dislike',
    }
  },

  computed: {
    name() {
      return this.$t(`insights.widget_names.${_.snakeCase(this.widget)}`)
    },
  },

  methods: {
    handleCancel() {
      this.showFeedbackDialog = false
      this.feedbackComments = ''
      this.likeIcon = 'mdi-thumb-up-outline'
      this.dislikeIcon = 'mdi-thumb-down-outline'
      this.likeSent = false
      this.selection = 'dislike'
    },

    handleLikeClick(widget) {
      this.trackInsightsFeedbackLike({
        widget,
      })
      window.localStorage.setItem(
        `widgetFeedbackDate-${widget}`,
        Date.now().toString()
      )

      this.likeIcon = 'mdi-thumb-up'
      this.showFeedbackDialog = false
      this.feedbackComments = ''
      _.delay(() => {
        this.likeSent = true
      }, 500)

      _.delay(() => {
        this.$emit('feedbackGiven')
      }, 2000)
    },

    handleSend(widget) {
      if (this.selection === 'dislike') {
        this.trackInsightsFeedbackDisLike({
          widget,
          comments: this.feedbackComments,
        })
      } else {
        this.trackInsightsFeedbackLike({
          widget,
          comments: this.feedbackComments,
        })
      }
      window.localStorage.setItem(
        `widgetFeedbackDate-${widget}`,
        Date.now().toString()
      )
      this.showFeedbackDialog = false
      this.feedbackComments = ''
      this.showSuccess(this.$t('insights.feedback_sent'))
      this.$emit('feedbackGiven')
    },
  },
}
</script>

<style lang="scss">
.feedback-icon {
  color: $color-blue-grey !important;
  &:hover {
    color: $color-blue-lighten1 !important;
  }
  &:focus {
    color: $color-blue !important;
  }
  &::after {
    background-color: transparent !important;
  }
}

.feedback-chip {
  position: absolute;
  top: -14px;
  right: 10px;
  &:hover::before {
    opacity: 1;
    background-color: white !important;
  }
}
.feedback-chip.v-chip {
  line-height: 16px !important;
  .v-chip__content {
    height: 16px !important;
  }
}
</style>
